import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaArrowRight, FaClock, FaUser, FaFire } from "react-icons/fa";
import "./HomeBlogs.css";

const HomeBlogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const response = await axios.get("https://api.swasthmitra.com/api/blogs");
      setBlogs(response.data.slice(0, 3)); // Get only the latest 3 blogs
      setLoading(false);
    } catch (error) {
      console.error("Error fetching blogs:", error);
      setLoading(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const cardVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 12,
      },
    },
  };

  if (loading) {
    return (
      <div className="loading">
        <div className="loading-spinner"></div>
        Loading health insights...
      </div>
    );
  }

  return (
    <section className="homeBlogs">
      <div className="homeBlogsHeader">
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="section-title"
        >
          <FaFire className="title-icon" />
          Health Insights & Tips
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="section-subtitle"
        >
          Discover expert advice and the latest medical knowledge to empower your wellness journey
        </motion.p>
      </div>

      <motion.div
        className="homeBlogsScroll"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <div className="blogsScrollContainer">
          {blogs.map((blog) => (
            <motion.div
              key={blog._id}
              className="homeBlogCard"
              variants={cardVariants}
              whileHover={{ scale: 1.03 }}
            >
              <div className="blogCardImage">
                <img src={blog.imageUrl} alt={blog.title} />
                <div className="blogCategory">{blog.category}</div>
                <div className="blogOverlay"></div>
              </div>
              <div className="blogCardContent">
                <div className="blogMeta">
                  <span>
                    <FaUser className="meta-icon" /> {blog.author}
                  </span>
                  <span>
                    <FaClock className="meta-icon" /> {blog.readTime} min read
                  </span>
                </div>
                <h3>{blog.title}</h3>
                <p className="blogExcerpt">
                  {blog.excerpt || `${blog.content.substring(0, 100)}...`}
                </p>
                <Link
                  to={`/blog/${blog._id}`}
                  className="readMore"
                  onClick={scrollToTop}
                >
                  Continue Reading <FaArrowRight className="arrow-icon" />
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>

      <motion.div
        className="viewAllBlogs"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.5 }}
      >
        <Link to="/blog" className="viewAllButton" onClick={scrollToTop}>
          Explore All Articles
          <FaArrowRight className="button-arrow" />
        </Link>
      </motion.div>
    </section>
  );
};

export default HomeBlogs;